import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface GroupByThemeDialogProps {
  cardCount: number;
  error: string | null;
  isGrouping: boolean;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function GroupByThemeDialog({
  cardCount,
  error,
  isGrouping,
  open,
  onClose,
  onConfirm,
}: GroupByThemeDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={isGrouping ? undefined : onClose}
      aria-labelledby="group-by-theme-dialog-title"
      aria-describedby="group-by-theme-dialog-description"
    >
      <DialogTitle id="group-by-theme-dialog-title">Group cards by theme?</DialogTitle>
      <DialogContent>
        <DialogContentText id="group-by-theme-dialog-description">
          AI will analyze {cardCount} ungrouped text {cardCount === 1 ? 'card' : 'cards'}, create new
          theme clusters, and move matching cards into them. Existing connections on moved cards
          will be deleted. Cards without a matching theme will remain ungrouped.
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isGrouping}>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" disabled={isGrouping}>
          {isGrouping ? 'Grouping…' : 'Group cards'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
